// extracted by mini-css-extract-plugin
export default {"list":"love-emotion_list__Dpj55","arrow_icon":"love-emotion_arrow_icon__IrnxY"};